import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
	'inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-0 focus:ring-offset-0',
	{
		variants: {
			variant: {
				default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
				secondary:
					'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
				destructive:
					'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
				outline: 'text-foreground'
			}
		},
		defaultVariants: {
			variant: 'default'
		}
	}
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {
	'aria-label'?: string;
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
	({ className, variant, 'aria-label': ariaLabel, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={cn(badgeVariants({ variant }), className)}
				aria-label={ariaLabel}
				{...props}
			/>
		);
	}
);
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
